module.exports = __webpack_public_path__ + "img/14.ef5360f5.png";